export default __webpack_public_path__ + "static/media/logo.a3c34db4.svg";